import React, { Fragment, Component } from 'react';
import { Translate } from '../Localization/Translate';

class SummaryBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentLoaded: false,
        };
    }

    componentDidMount() {
        this.setState({
            componentLoaded: true
        });
    }

    render() {
        const { showSummaryData, summaryData, coolingAndWarmWaterObject, powerValues } = this.props;
        const { componentLoaded } = this.state;
        return (
            <Fragment>
                {componentLoaded &&
                    <Fragment>
                        {showSummaryData &&
                            <div className="summary__box">
                                <h3>{Translate("QuoteTool/summary/summarytitle")}</h3>
                                <ul>
                                    {summaryData.pumpType.value && <li><b>{summaryData.pumpType.title}:</b> {Translate('QuoteTool/step2/' + summaryData.pumpType.value + 'label')}</li>}
                                    {summaryData.pump.value && <li><b>{summaryData.pump.title}:</b> {summaryData.pump.value}</li>}
                                    {summaryData.power.value !== null && summaryData.power.value !== NaN && summaryData.power.value !== '0' && summaryData.power.value !== '' && <li><b>{summaryData.power.title}:</b> {summaryData.power.value}</li>}
                                    {powerValues.gasUsage !== '0' && powerValues.gasUsage !== 0 && powerValues.gasUsage !== '' && <li><b>{summaryData.gasUsage.title}:</b> {powerValues.gasUsage}</li>}
                                    {summaryData.cooling.value && coolingAndWarmWaterObject.quoteCooling !== undefined && <li><b>{summaryData.cooling.title}:</b>  {Translate('QuoteTool/general/' + (coolingAndWarmWaterObject.quoteCooling))}</li>}
                                    {summaryData.tapwater.value && coolingAndWarmWaterObject.quoteTapWater !== undefined && <li><b>{summaryData.tapwater.title}:</b> {Translate('QuoteTool/general/' + (coolingAndWarmWaterObject.quoteTapWater))}</li>}
                                    {summaryData.waterConsumption.value && <li><b>{summaryData.waterConsumption.title}:</b> {coolingAndWarmWaterObject.waterPeak}</li>}
                                </ul>
                            </div>
                        }
                    </Fragment>
                }
            </Fragment>
        );
    }
}

export default SummaryBox;